import {
  GET_ACTIVE_FILTERS_SUCCESS,
  GET_APP_STATISTIC_SUCCESS,
  HIDE_NOTIFICATION,
  SHOW_NOTIFICATION,
  TOGGLE_AUTH_MODAL
} from './appConstants';
import { filterNames } from '../../app/constants/filters';

const initialState = {
  statistic: {
    companies: 0,
    services: 0,
  },
  activeFilters: {
    [filterNames.SERVICES]: [],
    [filterNames.KANTONES]: [],
    [filterNames.LOCATIONS]: [],
    [filterNames.LANGUAGES]: [],
    [filterNames.MEMBER]: [],
  },
  authModal: { // TODO: move it later for modals module
    open: false,
    layout: null,
  },
  notificationBar: {
    messages: [] // { text, msgType, id }
  }
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_AUTH_MODAL: {
      return {
        ...state,
        authModal: {
          ...state.authModal,
          ...payload,
        }
      }
    }
    case SHOW_NOTIFICATION: {
      return {
        ...state,
        notificationBar: {
          messages: [ ...state.notificationBar.messages, payload ],
        }
      }
    }
    case HIDE_NOTIFICATION: {
      return {
        ...state,
        notificationBar: {
          messages: state.notificationBar.messages.filter(i => i.id !== payload) // payload is id
        }
      }
    }
    case GET_APP_STATISTIC_SUCCESS: {
      return {
        ...state,
        statistic: {
          companies: payload.companiesCount,
          services: payload.servicesCount,
        }
      }
    }
    case GET_ACTIVE_FILTERS_SUCCESS: {
     return {
       ...state,
       activeFilters: payload
     }
    }
    default:
      return state;
  }

}
